/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ManagerResource
 */
export interface ManagerResource {
    /**
     * 
     * @type {string}
     * @memberof ManagerResource
     */
    managerId: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerResource
     */
    fullName: string;
}

/**
 * Check if a given object implements the ManagerResource interface.
 */
export function instanceOfManagerResource(value: object): value is ManagerResource {
    if (!('managerId' in value) || value['managerId'] === undefined) return false;
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    return true;
}

export function ManagerResourceFromJSON(json: any): ManagerResource {
    return ManagerResourceFromJSONTyped(json, false);
}

export function ManagerResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManagerResource {
    if (json == null) {
        return json;
    }
    return {
        
        'managerId': json['managerId'],
        'fullName': json['fullName'],
    };
}

export function ManagerResourceToJSON(value?: ManagerResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'managerId': value['managerId'],
        'fullName': value['fullName'],
    };
}

